export default {
  buttons: {
    cancel: "ОТКАЖИ",
    dismiss: "Затвори",
    add_waypoint: "до"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  search: {
    title: "Търсене",
    placeholder: "Въведете местоположение",
    enter_location: "Въведете местоположение",
    help: {
      inactive: "Търсене"
    }
  },
  filters: {
    title: "Филтри",
    amenities: {
      title: "Услуги и удобства"
    },
    fuels: {
      title: "Видове горива"
    }
  },
  directions: {
    title: "Планиране на маршрут",
    placeholder: {
      destination: "Въведете местоположение",
      waypoint: "Въведете местоположение"
    },
    route: {
      title: "Маршрути",
      avoid_tolls: "Избягване на платени пътни участъци ",
      avoid_highways: "Избягване на магистрали",
      title_corridor: "Отклонение от маршрута до бензиностанция"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# ден} other {# ден}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# mins}}\
`,
    button: "Търсене"
  },
  locations: {
    title: "Обекти",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} от {place}"
  },
  info_window: {
    title: "Информация за бензиностанцията ",
    location_id: "ID на бензиностанция",
    services: "Услуги и удобства",
    nearby: "Наблизо",
    mobile: {
      telephone: "Тел:"
    },
    opening_hours: {
      title: "Работно време ",
      mon: "Пон.",
      tue: "Вт.",
      wed: "Ср.",
      thu: "Чет.",
      fri: "Пет.",
      sat: "Съб.",
      sun: "Нед.",
      open_twentyfourhours: "Отворено 24/7",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Последна актуализация",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Планиране на маршрут"
  },
  fuels: {
    adblue: "Adblue",
    autogas_lpg: "Shell AutoGas",
    fuelsave_midgrade_gasoline: "Shell FuelSave 95",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power 95",
    super_premium_gasoline: "Shell V-Power Racing"
  },
  amenities: {
    air_and_water: "Въздух",
    atm: "Банкомат",
    austrian_highway_sticker: "Винетен стикер за Австрия",
    bank_note_acceptor: "Машина за депозиране на пари в брой",
    bottled_gas: "Подмяна на битови газови  бутилки ",
    cafe: "Кафетерия",
    carwash: "Автомивка",
    clubsmart_card: "CLUBSMART карта",
    credit_card_american_express: "Кредитна карта - American Express",
    credit_card_diners_club: "Кредитна карта - Diners Club",
    credit_card_mastercard: "Кредитна карта - Mastercard",
    credit_card_visa: "Кредитна карта - Visa",
    credit_card: "Кредитна карта",
    czech_highway_sticker: "Винетен стикер за Чехия",
    euroshell_card: "euroShell",
    fleet_card_dkv: "DKV карта",
    fleet_card_eni: "Eni карта",
    fleet_card_esso: "Esso карта",
    fleet_card_general: "euroShell карта",
    fleet_card_uta: "UTA карта",
    food_offerings: "Меню",
    full_service: "Пълно обслужване",
    guarded_car_park: "Охраняем паркинг",
    hgv_lane: "Подходящо за камиони",
    high_speed_diesel_pump: "Високодебитна колонка за дизел",
    hot_food: "Топла храна",
    hungarian_highway_sticker: "Винетен стикер за Унгария",
    ido_ticket: "Билет Ido",
    maut_terminal: "Терминал за камиони",
    parking_lanes: "Място за паркиране",
    pay_at_pump: "Плащане на колонката",
    quick_lubes: "Смяна на масло",
    restaurant: "Ресторант",
    self_service: "Самообслужване",
    service_bay: "Сервиз",
    shell_card: "euroShell",
    shell_club_smart_extra_card: "CLUBSMART Premium карта",
    shop: "Магазин",
    shower: "Душове",
    slovak_highway_sticker: "Винетен стикер за Словакия",
    snack_food: "Закуски/Бърза храна ",
    standard_toilet: "Тоалетна",
    supermarket_fuel_discount: "Отстъпка от цената на горивата ",
    toilet: "Тоалетна",
    truck_parking: "Паркинг за камиони",
    truckport: "Само за камиони",
    twenty_four_hour: "24 ч.",
    vacuum: "Прахосмукачка",
    vehicle_identity_system: "Система за идентифициране на автомобилите "
  },
  settings: {
    title: "Настройки",
    tooltip: "Настройки",
    distance_units: {
      title: "Разстояние",
      km: "километри",
      miles: "мили"
    },
    language: {
      title: "Език"
    }
  }
}
